// Clase de utilidad para validar y corregir consultas SQL - Esquema Cantabria Labs
export default class SQLValidator {
    constructor() {
        this.typeConflicts = [
            { pattern: /JOIN\s+\w+\s+\w+\s+ON\s+("?\w+[\s\w]*"?\.)"?[\w\s]+"?\s*=\s*("?\w+[\s\w]*"?\.)"?[\w\s]+"?/gi, types: ['text', 'double precision'] },
            { fields: ['"EAN WM"', '"UPC WM"', 'upc_wm_client', 'upc_wm_comp'], potentialConflict: true }
        ];

        // 1. Tablas del esquema Cantabria Labs
        this.tables = {
            'client': [
                'Departamento', '# Departamento', 'Categoría', '# Categoría', 
                'Subcategoría', '# Subcategoría', 'SKU', 'Descripción SKU', 
                'EAN', 'Marca', 'Precio sin promoción sin IVA', 
                'Precio sin promoción con IVA', 'Precio sin IVA', 'Precio con IVA',
                'IVA', 'Operable', 'Activo', 'Status', 'Dirección Comercial',
                'Proveedor', 'Comprador', 'Inventario', 'Margen', 'Margen min',
                'Grupo', 'PMP con IVA', '$ Ventas YTD', 'Ventas Pzas YTD',
                '$ Ventas MTD', 'Ventas Pzas MTD', 'Mercado MTD Pzas',
                'Mercado YTD Pzas', 'Mercado MTD $', 'Mercado YTD $', 'EAN WM'
            ],
            'competitors': [
                'Date', 'Canal', 'Category', 'Subcategory', 'Subcategory2',
                'Subcategory3', 'Marca', 'Modelo', 'SKU', 'UPC', 'Item',
                'Item Characteristics', 'URL SKU', 'Image', 'Price',
                'Sale Price', 'Shipment Cost', 'Sales Flag', 'Store ID',
                'Store Name', 'Store Address', 'Stock', 'UPC WM2',
                'Final Price', 'UPC WM', 'COMP', 'last_price'
            ],
            'match': [
                'upc_client', 'upc_wm_client', 'conc_upc_wm_client',
                'item_client', 'brand_client', 'category_client',
                'unit_client', 'measure_client', 'canal', 'upc_comp',
                'upc_wm_comp', 'conc_upc_wm_comp', 'item_comp',
                'brand_comp', 'category_comp', 'unit_comp', 'measure_comp',
                'rank', 'kit_comp', 'subcategory_comp', 'treatment_comp'
            ],
            'sell_out': [
                'fecha', 'cliente', 'upc', 'descripcion', 'unidades',
                'valor', 'mercado', 'anio', 'mes'
            ]
        };

        // 2. Alias map para las tablas de Cantabria Labs
        this.aliasMap = {
            'c': 'client',
            'cl': 'client',
            'cliente': 'client',
            'catalogo': 'client',
            'comp': 'competitors',
            'competidor': 'competitors',
            'competencia': 'competitors',
            'm': 'match',
            'matching': 'match',
            'vinculo': 'match',
            'so': 'sell_out',
            'sellout': 'sell_out',
            'ventas': 'sell_out',
            'distribucion': 'sell_out'
        };

        // 3. Compatibilidad de tipos para el esquema Cantabria Labs
        this.typeCompatibility = {
            // client - TODOS los campos son TEXT
            'client.Departamento': 'text',
            'client.# Departamento': 'text',
            'client.Categoría': 'text',
            'client.# Categoría': 'text',
            'client.Subcategoría': 'text',
            'client.# Subcategoría': 'text',
            'client.SKU': 'text',
            'client.Descripción SKU': 'text',
            'client.EAN': 'text',
            'client.Marca': 'text',
            'client.Precio sin promoción sin IVA': 'text',
            'client.Precio sin promoción con IVA': 'text',
            'client.Precio sin IVA': 'text',
            'client.Precio con IVA': 'text',
            'client.IVA': 'text',
            'client.Operable': 'text',
            'client.Activo': 'text',
            'client.Status': 'text',
            'client.Dirección Comercial': 'text',
            'client.Proveedor': 'text',
            'client.Comprador': 'text',
            'client.Inventario': 'text',
            'client.Margen': 'text',
            'client.Margen min': 'text',
            'client.Grupo': 'text',
            'client.PMP con IVA': 'text',
            'client.$ Ventas YTD': 'text',
            'client.Ventas Pzas YTD': 'text',
            'client.$ Ventas MTD': 'text',
            'client.Ventas Pzas MTD': 'text',
            'client.Mercado MTD Pzas': 'text',
            'client.Mercado YTD Pzas': 'text',
            'client.Mercado MTD $': 'text',
            'client.Mercado YTD $': 'text',
            'client.EAN WM': 'text',

            // competitors - campos mixtos
            'competitors.Date': 'text',
            'competitors.Canal': 'text',
            'competitors.Category': 'text',
            'competitors.Subcategory': 'text',
            'competitors.Subcategory2': 'text',
            'competitors.Subcategory3': 'text',
            'competitors.Marca': 'text',
            'competitors.Modelo': 'text',
            'competitors.SKU': 'text',
            'competitors.UPC': 'text',
            'competitors.Item': 'text',
            'competitors.Item Characteristics': 'text',
            'competitors.URL SKU': 'text',
            'competitors.Image': 'text',
            'competitors.Price': 'double precision',
            'competitors.Sale Price': 'double precision',
            'competitors.Shipment Cost': 'double precision',
            'competitors.Sales Flag': 'text',
            'competitors.Store ID': 'text',
            'competitors.Store Name': 'text',
            'competitors.Store Address': 'text',
            'competitors.Stock': 'double precision',
            'competitors.UPC WM2': 'text',
            'competitors.Final Price': 'double precision',
            'competitors.UPC WM': 'text',
            'competitors.COMP': 'double precision',
            'competitors.last_price': 'double precision',

            // match - todos los campos son TEXT
            'match.upc_client': 'text',
            'match.upc_wm_client': 'text',
            'match.conc_upc_wm_client': 'text',
            'match.item_client': 'text',
            'match.brand_client': 'text',
            'match.category_client': 'text',
            'match.unit_client': 'text',
            'match.measure_client': 'text',
            'match.canal': 'text',
            'match.upc_comp': 'text',
            'match.upc_wm_comp': 'text',
            'match.conc_upc_wm_comp': 'text',
            'match.item_comp': 'text',
            'match.brand_comp': 'text',
            'match.category_comp': 'text',
            'match.unit_comp': 'text',
            'match.measure_comp': 'text',
            'match.rank': 'text',
            'match.kit_comp': 'text',
            'match.subcategory_comp': 'text',
            'match.treatment_comp': 'text',

            // sell_out - TODOS los campos son TEXT
            'sell_out.fecha': 'text',
            'sell_out.cliente': 'text',
            'sell_out.upc': 'text',
            'sell_out.descripcion': 'text',
            'sell_out.unidades': 'text',
            'sell_out.valor': 'text',
            'sell_out.mercado': 'text',
            'sell_out.anio': 'text',
            'sell_out.mes': 'text'
        };
    }

    // Métodos de limpieza y validación
    cleanMarkdown(sql) {
        if (!sql || typeof sql !== 'string') return sql;
        let cleanedSQL = sql.replace(/^```sql\s*/g, '').replace(/^```\s*/g, '');
        cleanedSQL = cleanedSQL.replace(/\s*```$/g, '');
        return cleanedSQL;
    }

    checkIncompleteStructures(sql) {
        const errors = [];

        // Check for balanced CASE/END
        const caseCount = (sql.match(/\bCASE\b/gi) || []).length;
        const endCount = (sql.match(/\bEND\b/gi) || []).length;

        if (caseCount > endCount) {
            errors.push(`Hay ${caseCount - endCount} declaraciones CASE sin cerrar con END`);
        }

        // Verificación específica para operaciones con Date (que es text, no date real)
        const dateOps = [...sql.matchAll(/("Date"|Date)\s*([<>=!]+)\s*.*?\s*(-|\+)\s*INTERVAL\s+\'([^\']+)\'/gi)];

        for (const match of dateOps) {
            const column = match[1];
            if (!sql.includes(`TO_DATE(${column}`) && !sql.includes(`CAST(${column}`)) {
                errors.push(`Posible error: columna '${column}' es TEXT, no DATE. Usar TO_DATE() o filtros directos con strings`);
            }
        }

        // Check for incomplete CASE statements
        const incompleteCase = sql.match(/CASE\s*;/gi);
        if (incompleteCase) {
            errors.push('Declaración CASE incompleta encontrada');
        }

        // Check for incomplete WITH clauses
        if (sql.includes('WITH') && !sql.includes('SELECT')) {
            errors.push('Cláusula WITH sin SELECT correspondiente');
        }

        return errors;
    }

    validate(sql) {
        if (!sql || typeof sql !== 'string') {
            return { valid: false, errors: ['Consulta SQL vacía o inválida'] };
        }

        sql = sql.trim();
        const errors = [];

        // Verificaciones básicas
        if (!sql.toLowerCase().includes('select')) {
            errors.push('La consulta debe incluir una cláusula SELECT');
        }

        if (!sql.toLowerCase().includes('from')) {
            errors.push('La consulta debe incluir una cláusula FROM');
        }

        // Verificar paréntesis balanceados
        const openParens = (sql.match(/\(/g) || []).length;
        const closeParens = (sql.match(/\)/g) || []).length;
        if (openParens !== closeParens) {
            errors.push(`Paréntesis desbalanceados: ${openParens} abiertos vs ${closeParens} cerrados`);
        }

        // Verificar comillas balanceadas
        const quotes = (sql.match(/'/g) || []).length;
        if (quotes % 2 !== 0) {
            errors.push('Comillas simples desbalanceadas');
        }

        // Verificar alias de tablas
        for (const [alias, table] of Object.entries(this.aliasMap)) {
            if (sql.includes(`${alias}.`) &&
                !sql.includes(`${table} ${alias}`) &&
                !sql.includes(`${table} AS ${alias}`)) {
                errors.push(`Referencia a alias "${alias}" sin definición previa`);
            }
        }

        return {
            valid: errors.length === 0,
            errors: errors
        };
    }

    fixQuery(sql, errorMessage = '') {
        let fixedSQL = sql.trim();
        let wasFixed = false;
        let fixes = [];

        // Primero limpiar cualquier formato Markdown
        const originalSQL = fixedSQL;
        fixedSQL = this.cleanMarkdown(fixedSQL);
        if (originalSQL !== fixedSQL) {
            wasFixed = true;
            fixes.push('Eliminado formato Markdown');
        }

        // CRÍTICO: Recordatorio de que los campos en client y sell_out son TEXT
        if (errorMessage.includes("function") && errorMessage.includes("does not exist") && 
            (errorMessage.includes("client") || errorMessage.includes("sell_out") ||
             errorMessage.includes("Precio") || errorMessage.includes("Ventas") || 
             errorMessage.includes("Margen") || errorMessage.includes("Inventario") || 
             errorMessage.includes("Mercado") || errorMessage.includes("unidades") || 
             errorMessage.includes("valor"))) {
            
            const beforeCastFix = fixedSQL;
            
            // Buscar operaciones matemáticas sin CAST en campos de client
            const numericFieldsClient = [
                'Precio sin promoción sin IVA', 'Precio sin promoción con IVA',
                'Precio sin IVA', 'Precio con IVA', 'IVA', 'Inventario',
                'Margen', 'Margen min', 'PMP con IVA', '$ Ventas YTD',
                'Ventas Pzas YTD', '$ Ventas MTD', 'Ventas Pzas MTD',
                'Mercado MTD Pzas', 'Mercado YTD Pzas', 'Mercado MTD $', 'Mercado YTD $'
            ];

            numericFieldsClient.forEach(field => {
                const fieldRegex = new RegExp(`(\\w+\\.)?"${field}"(?!\\s*(AS|::)\\s*NUMERIC)`, 'gi');
                if (fixedSQL.match(fieldRegex)) {
                    fixedSQL = fixedSQL.replace(fieldRegex, `CAST($1"${field}" AS NUMERIC)`);
                }
            });

            // Buscar operaciones matemáticas sin CAST en campos de sell_out
            const numericFieldsSellOut = ['unidades', 'valor'];
            
            numericFieldsSellOut.forEach(field => {
                const fieldRegex = new RegExp(`(\\w+\\.)?${field}(?!\\s*(AS|::)\\s*NUMERIC)`, 'gi');
                if (fixedSQL.match(fieldRegex)) {
                    fixedSQL = fixedSQL.replace(fieldRegex, `CAST($1${field} AS NUMERIC)`);
                }
            });

            if (beforeCastFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido CAST(... AS NUMERIC) a campos de client y sell_out (todos son TEXT)');
            }
        }

        // Corregir función ROUND con AVG
        if (fixedSQL.includes('ROUND(') && fixedSQL.includes('AVG(')) {
            const beforeRoundFix = fixedSQL;
            fixedSQL = fixedSQL.replace(/ROUND\s*\(\s*AVG\s*\(\s*([^)]+)\s*\)\s*,\s*([0-9]+)\s*\)/g, 'ROUND(AVG($1)::numeric, $2)');

            if (beforeRoundFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido cast ::numeric a función ROUND con AVG');
            }
        }

        // Corrección específica para Date (es TEXT, no DATE)
        if (errorMessage.includes("operator does not exist: text - interval") ||
            errorMessage.includes("operator does not exist: text + interval") ||
            (errorMessage.includes("Date") && errorMessage.includes("interval"))) {

            const beforeDateFix = fixedSQL;

            // Reemplazar operaciones con INTERVAL en Date por comparaciones directas
            fixedSQL = fixedSQL.replace(
                /"?Date"?\s*([<>=!]+)\s*.*?(-|\+)\s*INTERVAL\s+\'([^\']+)\'/gi,
                (match, operator) => {
                    return `"Date" ${operator} '2025-01-01'`; // Fallback
                }
            );

            if (beforeDateFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Corregido Date: es TEXT, no DATE - usar TO_DATE() o filtros directos con strings');
            }
        }

        // Corrección para JOINs con tipos incompatibles
        if (errorMessage.includes("operator does not exist") &&
            (errorMessage.includes("double precision = text") || 
             errorMessage.includes("text = double precision"))) {

            const beforeJoinFix = fixedSQL;

            // Corregir JOINs entre client (TEXT) y competitors (double precision)
            const joinPatterns = [
                /(\w+)\."?(Price|Final Price|Sale Price|Stock|COMP|last_price)"?\s*=\s*(\w+)\."?([^"]+)"?/gi,
                /(\w+)\."?([^"]+)"?\s*=\s*(\w+)\."?(Price|Final Price|Sale Price|Stock|COMP|last_price)"?/gi
            ];

            joinPatterns.forEach(pattern => {
                fixedSQL = fixedSQL.replace(pattern, (match, alias1, field1, alias2, field2) => {
                    // Si uno es de competitors (double precision) y otro de client (text)
                    if (field1 && ['Price', 'Final Price', 'Sale Price', 'Stock', 'COMP', 'last_price'].includes(field1)) {
                        return `CAST(${alias1}."${field1}" AS TEXT) = ${alias2}."${field2}"`;
                    } else if (field2 && ['Price', 'Final Price', 'Sale Price', 'Stock', 'COMP', 'last_price'].includes(field2)) {
                        return `${alias1}."${field1}" = CAST(${alias2}."${field2}" AS TEXT)`;
                    }
                    return match;
                });
            });

            if (beforeJoinFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Corregido JOIN entre columnas de tipos incompatibles (double precision vs text)');
            }
        }

        // Fix ROUND function with explicit numeric casting
        if (errorMessage.includes("function round") && errorMessage.includes("does not exist")) {
            const beforeRoundFix = fixedSQL;

            fixedSQL = fixedSQL.replace(
                /ROUND\s*\(\s*([^,]+)\s*,\s*([^)]+)\s*\)/gi,
                'ROUND(CAST($1 AS numeric), $2)'
            );

            if (beforeRoundFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido cast explícito a numeric para función ROUND');
            }
        }

        // Corregir alias sin declarar
        for (const [alias, table] of Object.entries(this.aliasMap)) {
            if (fixedSQL.includes(`${alias}.`) &&
                !fixedSQL.includes(`${table} ${alias}`) &&
                !fixedSQL.includes(`${table} AS ${alias}`)) {

                if (fixedSQL.includes(`FROM ${table}`)) {
                    const beforeAliasFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(`FROM ${table}`, `FROM ${table} ${alias}`);

                    if (beforeAliasFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Añadido alias "${alias}" a la tabla "${table}"`);
                    }
                }
            }
        }

        // Añadir punto y coma al final si falta
        if (!fixedSQL.trim().endsWith(';')) {
            fixedSQL = fixedSQL.trim() + ';';
            wasFixed = true;
            fixes.push('Añadido punto y coma al final');
        }

        // Correcciones específicas para nombres de tabla del esquema Cantabria Labs
        if (errorMessage.includes('relation') && errorMessage.includes('does not exist')) {
            const match = errorMessage.match(/relation\s+"?([^"]+)"?/i);
            if (match && match[1]) {
                const badTable = match[1].trim();

                const commonTableFixes = {
                    'cliente': 'client',
                    'clientes': 'client',
                    'catalogo': 'client',
                    'productos': 'client',
                    'product': 'client',
                    'items': 'client',
                    'competidor': 'competitors',
                    'competidores': 'competitors',
                    'competencia': 'competitors',
                    'competitor': 'competitors',
                    'comp_data': 'competitors',
                    'precios_comp': 'competitors',
                    'matching': 'match',
                    'matches': 'match',
                    'vinculo': 'match',
                    'vinculos': 'match',
                    'relacion': 'match',
                    'sellout': 'sell_out',
                    'sell-out': 'sell_out',
                    'ventas': 'sell_out',
                    'ventas_canal': 'sell_out',
                    'distribucion': 'sell_out',
                    'sell_out_data': 'sell_out'
                };

                if (commonTableFixes[badTable]) {
                    const beforeTableFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(new RegExp(`\\b${badTable}\\b`, 'g'), commonTableFixes[badTable]);

                    if (beforeTableFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Corregido nombre de tabla "${badTable}" a "${commonTableFixes[badTable]}"`);
                    }
                }
            }
        }

        // Correcciones para nombres de columnas del esquema Cantabria Labs
        if (errorMessage.includes('column') && errorMessage.includes('does not exist')) {
            const match = errorMessage.match(/column\s+"?([^"]+)"?/i);
            if (match && match[1]) {
                const badColumn = match[1].trim();

                const commonColumnFixes = {
                    // Campos de categorización
                    'departamento': 'Departamento',
                    'categoria': 'Categoría',
                    'subcategoria': 'Subcategoría',
                    'department': 'Departamento',
                    'category': 'Categoría',
                    'subcategory': 'Subcategoría',
                    
                    // Campos de producto
                    'sku': 'SKU',
                    'producto': 'Descripción SKU',
                    'descripcion': 'Descripción SKU',
                    'description': 'Descripción SKU',
                    'product': 'Descripción SKU',
                    'ean': 'EAN',
                    'codigo_barras': 'EAN',
                    'barcode': 'EAN',
                    'marca': 'Marca',
                    'brand': 'Marca',
                    
                    // Campos de precio
                    'precio': 'Precio con IVA',
                    'price': 'Precio con IVA',
                    'precio_actual': 'Precio con IVA',
                    'precio_regular': 'Precio sin promoción con IVA',
                    'precio_lista': 'Precio sin promoción con IVA',
                    'precio_sin_iva': 'Precio sin IVA',
                    'precio_con_iva': 'Precio con IVA',
                    'pmp': 'PMP con IVA',
                    'precio_medio': 'PMP con IVA',
                    
                    // Campos de ventas
                    'ventas': 'Ventas Pzas YTD',
                    'sales': 'Ventas Pzas YTD',
                    'ventas_ytd': 'Ventas Pzas YTD',
                    'ventas_mtd': 'Ventas Pzas MTD',
                    'ventas_piezas': 'Ventas Pzas YTD',
                    'ventas_pesos': '$ Ventas YTD',
                    'revenue': '$ Ventas YTD',
                    
                    // Campos de mercado
                    'mercado': 'Mercado YTD Pzas',
                    'market': 'Mercado YTD Pzas',
                    'mercado_ytd': 'Mercado YTD Pzas',
                    'mercado_mtd': 'Mercado MTD Pzas',
                    
                    // Campos de rentabilidad
                    'margen': 'Margen',
                    'margin': 'Margen',
                    'margen_minimo': 'Margen min',
                    'min_margin': 'Margen min',
                    'inventario': 'Inventario',
                    'stock': 'Inventario',
                    'inventory': 'Inventario',
                    
                    // Campos de estado
                    'activo': 'Activo',
                    'active': 'Activo',
                    'status': 'Status',
                    'estado': 'Status',
                    'operable': 'Operable',
                    
                    // Campos de organización
                    'proveedor': 'Proveedor',
                    'supplier': 'Proveedor',
                    'comprador': 'Comprador',
                    'buyer': 'Comprador',
                    'grupo': 'Grupo',
                    'group': 'Grupo',
                    
                    // Campos de competidores
                    'fecha': 'Date',
                    'date': 'Date',
                    'canal': 'Canal',
                    'channel': 'Canal',
                    'modelo': 'Modelo',
                    'model': 'Modelo',
                    'precio_final': 'Final Price',
                    'final_price': 'Final Price',
                    'precio_venta': 'Sale Price',
                    'sale_price': 'Sale Price',
                    'promocion': 'Sales Flag',
                    'promo': 'Sales Flag',
                    'flag_venta': 'Sales Flag',
                    'url': 'URL SKU',
                    'imagen': 'Image',
                    'image': 'Image',
                    'tienda': 'Store Name',
                    'store': 'Store Name',
                    'direccion': 'Store Address',
                    'address': 'Store Address',
                    'ultimo_precio': 'last_price',
                    
                    // Campos de match
                    'upc': 'upc_client',
                    'upc_wm': 'upc_wm_client',
                    'item': 'item_client',
                    'unidad': 'unit_client',
                    'unit': 'unit_client',
                    'medida': 'measure_client',
                    'measure': 'measure_client',
                    'ranking': 'rank',
                    'tratamiento': 'treatment_comp',
                    'treatment': 'treatment_comp',
                    
                    // Campos de sell_out (NUEVOS)
                    'date_sellout': 'fecha',
                    'fecha_venta': 'fecha',
                    'sale_date': 'fecha',
                    'customer': 'cliente',
                    'distribuidor': 'cliente',
                    'distributor': 'cliente',
                    'canal_venta': 'cliente',
                    'upc_code': 'upc',
                    'codigo_upc': 'upc',
                    'product_code': 'upc',
                    'desc': 'descripcion',
                    'description_sellout': 'descripcion',
                    'producto_descripcion': 'descripcion',
                    'qty': 'unidades',
                    'quantity': 'unidades',
                    'units': 'unidades',
                    'cantidad': 'unidades',
                    'piezas': 'unidades',
                    'amount': 'valor',
                    'value': 'valor',
                    'total': 'valor',
                    'importe': 'valor',
                    'monto': 'valor',
                    'market': 'mercado',
                    'region': 'mercado',
                    'zona': 'mercado',
                    'area': 'mercado',
                    'year': 'anio',
                    'año': 'anio',
                    'month': 'mes',
                    'periodo': 'mes',
                    'period': 'mes'
                };

                if (commonColumnFixes[badColumn]) {
                    const beforeColumnFix = fixedSQL;
                    
                    // Para columnas de sell_out (sin comillas dobles) y otras con comillas
                    const sellOutColumns = ['fecha', 'cliente', 'upc', 'descripcion', 'unidades', 'valor', 'mercado', 'anio', 'mes'];
                    const fixedColumn = commonColumnFixes[badColumn];
                    
                    if (sellOutColumns.includes(fixedColumn)) {
                        // Columnas de sell_out no llevan comillas dobles
                        fixedSQL = fixedSQL.replace(
                            new RegExp(`\\b${badColumn}\\b`, 'g'),
                            fixedColumn
                        );
                    } else {
                        // Otras columnas sí llevan comillas dobles
                        fixedSQL = fixedSQL.replace(
                            new RegExp(`\\b${badColumn}\\b`, 'g'),
                            `"${fixedColumn}"`
                        );
                    }

                    if (beforeColumnFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Corregido nombre de columna "${badColumn}" a "${fixedColumn}"`);
                    }
                }
            }
        }

        return {
            sql: fixedSQL,
            wasFixed,
            fixes
        };
    }

    // Función para calcular similitud entre cadenas
    stringSimilarity(s1, s2) {
        if (!s1 || !s2) return 0;
        s1 = s1.toLowerCase();
        s2 = s2.toLowerCase();
        if (s1 === s2) return 1.0;

        let matches = 0;
        for (let i = 0; i < Math.min(s1.length, s2.length); i++) {
            if (s1[i] === s2[i]) matches++;
        }
        return matches / Math.max(s1.length, s2.length);
    }

    processQuery(sql, errorMessage = '') {
        sql = this.cleanMarkdown(sql);

        // First check for common syntax issues
        const structuralErrors = this.checkIncompleteStructures(sql);
        if (structuralErrors.length > 0) {
            console.warn("Errores estructurales detectados:", structuralErrors);
        }

        // Check for unbalanced elements
        const unbalancedElements = this.checkUnbalancedElements(sql);
        if (unbalancedElements.length > 0) {
            console.warn("Elementos no balanceados:", unbalancedElements);
        }

        // Perform normal validation
        const validationResult = this.validate(sql);

        // If any errors or explicit error message, fix the query
        if (!validationResult.valid || errorMessage ||
            structuralErrors.length > 0 || unbalancedElements.length > 0) {
            return this.fixQuery(sql, errorMessage);
        }

        return {
            sql: sql,
            wasFixed: false,
            fixes: []
        };
    }

    // New method to check for unbalanced elements
    checkUnbalancedElements(sql) {
        const errors = [];

        // Check for balanced parentheses
        const openParens = (sql.match(/\(/g) || []).length;
        const closeParens = (sql.match(/\)/g) || []).length;
        if (openParens !== closeParens) {
            errors.push(`Paréntesis desbalanceados: ${openParens} abiertos vs ${closeParens} cerrados`);
        }

        // Check for balanced quotes
        const singleQuotes = (sql.match(/'/g) || []).length;
        if (singleQuotes % 2 !== 0) {
            errors.push('Comillas simples desbalanceadas');
        }

        // Check for balanced double quotes
        const doubleQuotes = (sql.match(/"/g) || []).length;
        if (doubleQuotes % 2 !== 0) {
            errors.push('Comillas dobles desbalanceadas');
        }

        return errors;
    }
}